import { Validator } from "jsonschema";
var validator = new Validator();
var schemas = new Map();
export var isString = function(val) {
    return typeof val === "string";
};
export var isNotEmpty = function(val) {
    return isString(val) && val !== "";
};
export var isDefined = function(val) {
    return typeof val !== "undefined";
};
export var isTruthy = function(val) {
    return !!val;
};
export var implementsType = function(obj, schema) {
    var onValidationError = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).onValidationError;
    if (!schemas.has(schema.id)) {
        validator.addSchema(schema, schema.id);
        schemas.set(schema.id, schema);
    }
    var result = validator.validate(obj, schema);
    if (!result.valid && onValidationError) {
        onValidationError(result);
    }
    return result.valid;
};
